export default __webpack_public_path__ + "static/media/Touch-App-Geraeteabbildung_Ultramat_23_2_675x267px.5653f74c.png";